import { AxiosResponse } from "axios";
import { api } from "../library/axios";
import { API_ROUTE } from "../const/apiRoute";
import { HanderResponse } from "../_base/helper/FunctionHelper";
import { NotificationExtension } from "../_base/extension/NotificationExtension";

export const uploadImageAddFolder = async (
  forderFile: string,
  dataSubmit: File[]
): Promise<any> => {
  try {
    const formData = new FormData();
    for (let index = 0; index < dataSubmit.length; index++) {
      const file = dataSubmit[index];

      if (!(file instanceof File)) {
        NotificationExtension.Fails("Dữ liệu không hợp lệ !");
        return;
      }

      formData.append("files", file);
    }

    const response: AxiosResponse = await api.post(
      API_ROUTE.UPLOAD_FILE + `?forderFile=${forderFile}`,
      formData,
      {
        headers: {
          "Content-Type": "multipart/form-data",
        },
      }
    );
    return response.data;
  } catch (error) {
    HanderResponse(error);
  }
};
